module.exports = __webpack_public_path__ + "img/home-icon-3.f71c4375.svg";